import React, { useEffect } from "react";
import { useAuthService } from "../../services";
import { useSearchParams } from "react-router-dom";
import { ApiUrl,NotifyType } from "../../util/app-config";
import { notify } from "../../util"

function MyInfoLogin() {
  const { createLoginSession, initMyInfoAuth } = useAuthService();
  let[searchParam,setSearchPara]=useSearchParams();
  const { message } = notify();

  useEffect(() => {
    const handleNavigate = async () => {
      let sessionData={
        userLoginType:searchParam.get("lt"),
        userType:searchParam.get("ut")
      }

      let session = await createLoginSession(sessionData,ApiUrl.CreateMIUserSession)
      if (!session || !session.state || !session.nonce) {
        message(NotifyType.Error, "Unable to create MyInfo login session")
        return;
      }

      const initAuthResponse = await initMyInfoAuth({
        state: session.state,
        nonce: session.nonce
      }, ApiUrl.MIInitAuth);

      if (initAuthResponse && initAuthResponse.authorizationUrl) {
        window.location.href = initAuthResponse.authorizationUrl;
      } else {
        message(NotifyType.Error, "Unable to initialize MyInfo authorization")
      }
    }

    handleNavigate();
  }, []);

  return <div>Redirecting..................</div>;
}

export default MyInfoLogin;
